import React, { FC } from 'react';
import classnames from 'classnames';
import { getStatus, printStatus } from '@src/util/opening';
import { StatusProps } from './props';
import './styles.scss';

export const Status: FC<StatusProps> = ({ state }) => {
  return <div className={classnames('opening-status', getStatus(state))}>{printStatus(state)}</div>;
};
